import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import { BadgeState, ProposalStatus } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import { th } from '@yoweb/ui/styles/utils/theme';
import { Flex } from '@yoweb/ui/components/Flex';
import { StarPicker } from '@yoweb/ui/components/StarPicker';
import { Text, Label } from '@yoweb/ui/components/typography';
import { AlertDot } from '@yoweb/ui/components/indicators';
import { Box } from '@yoweb/ui/components/Box';
import { Grid } from '@yoweb/ui/components/Grid';
import { CallCard } from '@poplar/components/CallCard';
import { InsetLink } from '@poplar/components/InsetLink';
import { PAGE_TODO_DETAILS } from '@poplar/constants/routes';
import { TaskLiteStatusBadge } from '@poplar/components/tasks/TaskStatusBadge';
import { ErrorIcon } from '@yoweb/ui/components/Icon/ErrorIcon';
import { RotateIcon } from '@yoweb/ui/components/Icon/RotateIcon';
import { Button } from '@yoweb/ui/components/buttons';
import { useTranslation } from '@yoweb/next-i18next';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { getActionItem, getRepeatInfoString } from '@poplar/utils/tasks';
import { QUERY_PROPOSAL_ID, QUERY_TASK_SECTION_ID } from '@poplar/constants/queryParams';
import { TaskSectionTypes } from '@poplar/types/enums';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaskActionCard = function TaskActionCard(_ref) {
  var task = _ref.task,
      isDeletingBookmark = _ref.isDeletingBookmark,
      onFeedbackRating = _ref.onFeedbackRating,
      onDeleteExpiredBookmark = _ref.onDeleteExpiredBookmark,
      onCallCardClick = _ref.onCallCardClick;
  var isRepeating = task.isRepeating,
      taskBadge = task.taskBadge,
      requiresMemberAttention = task.requiresMemberAttention,
      bookmarkExpired = task.bookmarkExpired,
      taskId = task.taskId,
      displayTitle = task.displayTitle,
      proposalSnippetsList = task.proposalSnippetsList;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  var _useState = useState(false),
      isFeedbackLoading = _useState[0],
      setIsFeedbackLoading = _useState[1];

  var actionItem = getActionItem(taskBadge, t);

  var _useExternalConfig = useExternalConfig(),
      enableRecuringTodos = _useExternalConfig.globalFeatures.enableRecuringTodos;

  var queryParams = new URLSearchParams();
  var baseUrl = PAGE_TODO_DETAILS(taskId);
  var linkHref = baseUrl;

  if (requiresMemberAttention) {
    var status = taskBadge === null || taskBadge === void 0 ? void 0 : taskBadge.type;
    var unconfirmedProposals = proposalSnippetsList.filter(function (p) {
      return p.status === ProposalStatus.PROPOSAL_STATUS_PUBLISHED;
    });

    if (status === BadgeState.BADGE_STATE_CHANNEL_UNREAD_COMMENTS) {
      queryParams.append(QUERY_TASK_SECTION_ID, TaskSectionTypes.messages);
      linkHref = "".concat(baseUrl, "?").concat(queryParams.toString());
    } else if ((status === BadgeState.BADGE_STATE_PROPOSAL_READY || status === BadgeState.BADGE_STATE_MULTIPLE_ITEMS_TO_REVIEW) && unconfirmedProposals.length === 1) {
      queryParams.append(QUERY_TASK_SECTION_ID, TaskSectionTypes.option);
      queryParams.append(QUERY_PROPOSAL_ID, unconfirmedProposals[0].id);
      linkHref = "".concat(baseUrl, "?").concat(queryParams.toString());
    }
  }

  var readyForFeedback = requiresMemberAttention && (taskBadge === null || taskBadge === void 0 ? void 0 : taskBadge.type) === BadgeState.BADGE_STATE_READY_FOR_GENERAL_FEEDBACK;
  return /*#__PURE__*/_jsx(CallCard, {
    "data-testid": "action-item-card",
    hoverable: true,
    children: /*#__PURE__*/_jsxs(Grid, {
      gap: "normal2",
      children: [/*#__PURE__*/_jsxs(Grid, {
        gap: "small3",
        children: [!bookmarkExpired && /*#__PURE__*/_jsx(Link, {
          href: linkHref,
          passHref: true,
          legacyBehavior: true,
          children: /*#__PURE__*/_jsx(InsetLink, {})
        }), /*#__PURE__*/_jsx(TaskLiteStatusBadge, {
          task: task
        }), /*#__PURE__*/_jsx(Box, {
          overflow: "hidden",
          children: /*#__PURE__*/_jsx(Text, {
            size: "lg",
            weight: "semibold",
            overflowWrap: "break-word",
            "data-testid": "task-action-task-name",
            children: displayTitle || t('task-intake-todo-default-title', {
              ns: 'common'
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Grid, {
        gap: "normal1",
        children: [enableRecuringTodos && isRepeating && /*#__PURE__*/_jsx(RecurringTodoLabel, {
          task: task
        }), actionItem && /*#__PURE__*/_jsxs(Flex, {
          alignItems: "baseline",
          columnGap: "small3",
          children: [/*#__PURE__*/_jsx(AlertDot, {
            color: "critical"
          }), /*#__PURE__*/_jsx(Label, {
            size: "xs",
            "data-testid": "task-action-label",
            children: actionItem
          })]
        })]
      }), bookmarkExpired && /*#__PURE__*/_jsxs(ErrorContainer, {
        "data-testid": "task-action-expired-bookmark",
        children: [/*#__PURE__*/_jsxs(Flex, {
          gap: "small3",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(IconWrapper, {
            children: /*#__PURE__*/_jsx(ErrorIcon, {
              size: 24,
              variant: "danger"
            })
          }), /*#__PURE__*/_jsx(Text, {
            size: "sm",
            children: t('expired-bookmark')
          })]
        }), onDeleteExpiredBookmark && /*#__PURE__*/_jsx(DeleteButton, {
          "data-testid": "delete-bookmarked-todo",
          variant: "secondary",
          type: "button",
          size: "sm",
          disabled: isDeletingBookmark,
          onClick: function onClick() {
            return onDeleteExpiredBookmark(task);
          },
          children: t('actions.delete-draft')
        })]
      }), readyForFeedback && /*#__PURE__*/_jsxs(CallCard, {
        onClick: onCallCardClick,
        hoverable: typeof onCallCardClick === 'function',
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        "data-testid": "task-action-inline-feedback",
        children: [/*#__PURE__*/_jsx(Text, {
          children: t('inline-feedback.how-did-we-do')
        }), /*#__PURE__*/_jsx(Box, {
          maxWidth: 250,
          children: /*#__PURE__*/_jsx(StarPicker, {
            count: 5,
            value: 0,
            gap: "small4",
            size: "100%",
            disabled: isFeedbackLoading,
            onChange: /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rating) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        setIsFeedbackLoading(true);
                        _context.next = 4;
                        return onFeedbackRating(rating);

                      case 4:
                        _context.prev = 4;
                        setIsFeedbackLoading(false);
                        return _context.finish(4);

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0,, 4, 7]]);
              }));

              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }()
          })
        })]
      })]
    })
  });
};

var RecurringTodoLabel = function RecurringTodoLabel(_ref3) {
  var task = _ref3.task;

  var _useTranslation2 = useTranslation('tasks'),
      t = _useTranslation2.t;

  var _useIntlMeta = useIntlMeta(),
      locale = _useIntlMeta.locale;

  var repeatInfoString = getRepeatInfoString(t, locale, task.repeatSetting);
  if (!repeatInfoString) return null;
  return /*#__PURE__*/_jsxs(RepeatInfoWrapper, {
    alignItems: "center",
    columnGap: "small2",
    children: [/*#__PURE__*/_jsx(RotateIcon, {}), /*#__PURE__*/_jsx(Label, {
      size: "xs",
      "data-testid": "repeating-task-label",
      children: repeatInfoString
    })]
  });
};

var DeleteButton = styled(Button).withConfig({
  componentId: "sc-10t85k5-0"
})(["&&{padding:", " ", ";border-width:1.5px;}"], th.getSpace('small4'), th.getSpace('small4'));
var ErrorContainer = styled.div.withConfig({
  componentId: "sc-10t85k5-1"
})(["background-color:", ";border-radius:", ";column-gap:", ";display:flex;padding:", ";align-items:center;justify-content:space-between;"], th.getColor('criticalLight'), th.getRadii('small'), th.getSpace('small4'), th.getSpace('small4'));
var IconWrapper = styled.div.withConfig({
  componentId: "sc-10t85k5-2"
})(["color:", ";display:flex;"], th.getColor('critical'));
var RepeatInfoWrapper = styled(Flex).withConfig({
  componentId: "sc-10t85k5-3"
})(["margin-left:-", ";"], th.getSpace('small1'));